import responseCFDIDocumentosIdNotaFactura from '../models/response-cfdi-documentos-idNotaFactura.model';
/*
  //Movil
  import RNFetchBlob from 'rn-fetch-blob' //descomentar cuando es movil
  import {PermissionsAndroid} from 'react-native';
  import {Alert} from 'react-native'
  export const {DateTimePicker} = require('@react-native-community/datetimepicker');
  export const {SplashScreen} = require('react-native-splash-screen');
  //Metodo que descarga el documento PDF o XML MOVIL
  export const downloadFile = async (type: string, files:responseCFDIDocumentosIdNotaFactura) => {
    let file = type == 'pdf' ? files.urlPdf : files.urlXml;
    let mime = type == 'pdf' ? 'application/pdf' : 'application/xml';
    try {
      const granted = await PermissionsAndroid.request(PermissionsAndroid.PERMISSIONS.WRITE_EXTERNAL_STORAGE);
      if (granted === PermissionsAndroid.RESULTS.GRANTED) {
        let location = `${RNFetchBlob.fs.dirs.DownloadDir}/Factura ${files.folio}.${type}`;
        RNFetchBlob.config({
          path: location,
          addAndroidDownloads: {
            useDownloadManager: true,
            notification: true,
            mime: mime,
            title: `Factura ${files.folio}.${type}`,
            description: location,
            path: location
          }
        }).fetch('GET', `${file}`).then((resp) => {
        })
      } else {
        Alert.alert('Permiso negado', 'Necesitas aceptar permisos de almacenamiento para poder descargar el archivo');
      }
    } catch (err) {
      console.warn(err);
    }
  }
*/
  //Web
  import React from 'react';
  export const DateTimePicker =  React.Component;
  export const SplashScreen = {hide: ()=>{}, other: ''};
  // Metodo que descarga el documento PDF o XML WEB
  export const downloadFile = (type: string, files:responseCFDIDocumentosIdNotaFactura) => {
    let file = type === 'pdf' ? files.pdf : files.xml;
    let mime = type === 'pdf' ? 'application/pdf' : 'application/xml';
    const downloadLink = document.createElement('a');
    const fileName = `Factura ${files.folio}.${type}`;
    downloadLink.href = `data:${mime};base64,${file}`;
    downloadLink.download = fileName;
    downloadLink.click();
  };
